import { Splide, ScrollComponent, LazyLoadComponent } from "@splidejs/splide";

export default Splide;
